import { AllDeeplinksPluginImpl } from "../data/AllDeeplinksPluginImpl";
import { AllDeeplinksPlugin } from "../domain/plugin/AllDeeplinksPlugin";
import { AllDeeplinksUseCase } from "../domain/usecase/AllDeeplinksUseCase";

export class DeeplinkFactory {
  static createDeeplinkPlugin(): AllDeeplinksPlugin {
    return new AllDeeplinksPluginImpl();
  }

  static createDeeplinkUseCase(): AllDeeplinksUseCase {
    return new AllDeeplinksUseCase(this.createDeeplinkPlugin());
  }
}
